"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Modal from "@/components/ui/Modal";
import { AppButton } from "@/components/ui/Button";

// Informational, not a picker: the service is only live in one city right
// now, so this just confirms that city rather than offering a list to choose
// from (see LIVE_CITY_ID in _constants/cities.js). No close button — Continue
// or "Browse ideas" are the only ways out, matching the Figma design.
export default function CitySelectionPopup(t0) {
  const $ = _c(24);
  const {
    open,
    cityLabel,
    cityIconSrc,
    onClose,
    onContinue,
    onBrowseDesigns
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: 0,
      gap: 0,
      borderRadius: "var(--radius28)",
      height: "auto",
      maxHeight: "none"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-start p-[--spacing24]"><Image src="/logos/fie-header-logo.svg" alt="Fevicol Interior Experts" width={223} height={24} className="h-auto w-full" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== cityLabel) {
    t3 = <h2 className="m3-title-large flex-1 text-[--textPrimaryPrimary]">We're live in {cityLabel}!</h2>;
    $[2] = cityLabel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== cityIconSrc) {
    t4 = <Image src={cityIconSrc} alt="" width={88} height={88} className="h-[88px] w-[88px] shrink-0" />;
    $[4] = cityIconSrc;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="flex items-center justify-center gap-[--spacing16] p-[--spacing24]">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onBrowseDesigns) {
    t6 = <button type="button" onClick={onBrowseDesigns} className="m3-label-large text-[--textLinkOnSurfaceLink]">Browse ideas</button>;
    $[9] = onBrowseDesigns;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backgroundColor: "var(--colorPrimaryPrimary)",
      color: "var(--textPrimaryOnColorPrimary)",
      borderRadius: "var(--radius100)",
      fontWeight: 600,
      paddingX: "24px",
      "&:hover": {
        backgroundColor: "var(--colorPrimaryPrimary)",
        opacity: 0.9
      }
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onContinue) {
    t8 = <AppButton label="Continue" variant="contained" height="40px" typographyClass="m3-label-large font-manrope" onClick={onContinue} sx={t7} />;
    $[12] = onContinue;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className="flex items-center justify-between gap-4 px-[--spacing16] py-6">{t6}{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t9) {
    t10 = <div className="flex flex-col">{t2}{t5}{t9}</div>;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onClose || $[21] !== open || $[22] !== t10) {
    t11 = <Modal open={open} onClose={onClose} showCloseButton={false} style={t1}>{t10}</Modal>;
    $[20] = onClose;
    $[21] = open;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}